/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Sharrow16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray}
            fillRule="evenodd"
            d="M8.815 2c.282 0 .49.105.777.358l.128.117 4.944 4.803c.254.24.336.495.336.722 0 .189-.06.408-.237.614l-.099.102-4.944 4.85c-.322.296-.59.434-.918.434-.43 0-.75-.287-.796-.694L8 13.202V11h-.353c-2.46 0-4.002.419-5.098 2.476-.233.434-.535.523-.836.523C1.336 14 1 13.642 1 12.995 1 8.3 2.97 5.127 7.38 5.005L7.647 5H8V2.84C8 2.38 8.336 2 8.815 2zM9 3.171v2.83H7.647c-3.515 0-5.391 2.118-5.623 6.122l-.014.3.034-.052c1.14-1.709 2.706-2.324 5.3-2.368l.303-.002H9v2.868l4.97-4.873L9 3.171z"
        />
    </AccessibleSVG>
);

export default Sharrow16;
